import { StoreState } from "store/index";

export const getSearchCriteria = (state: StoreState) => state.searchCriteria;
